export const SUB_CATEGORY_ACTION = 'SUB_CATEGORY_ACTION';
export const SUB_CATEGORY_SUCCESS_ACTION = 'SUB_CATEGORY_SUCCESS_ACTION';
export const SUB_CATEGORY_FAILURE_ACTION = 'SUB_CATEGORY_FAILURE_ACTION';
